import PropTypes from 'prop-types';
import React from 'react';
import { Dialog } from 'ui';
import './ChatD3Modal.scss';

function ChatD3Modal({ isOpen, onClose, title, url }) {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} title={title} size="all-screen" className="chat-d3-modal" hasSeparator>
      <div className="chat-d3-modal__content">
        <iframe src={url} width="100%" height="600" frameBorder="0" title={title} className="chat-d3-modal__iframe" allowFullScreen />
      </div>
    </Dialog>
  );
}

ChatD3Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default ChatD3Modal;
